import React from "react";
import { Box, Typography } from "@mui/material";

const LoadUser = () => {

  return (
        <Box sx={{ padding: "50px", alignItems: "center", justifyContent: "flex-start", textAlign: "center" }}>
            <Typography variant='h6'>Loading user information....</Typography>
        </Box>
    );
};

export default LoadUser;